<template>

  <!-- Recently Published -->
  <ArticleTable
    heading="Recently Published"
    :articles="recent"
    :hide="['stage']"
    date-label="Published"
    date-field="published_at"
    class="recently-published"
  />
</template>

<script>

// Components
import ArticleTable from '@/components/widgets/articles/ArticleTable'

// Vuex
import { createNamespacedHelpers } from 'vuex'
const { mapState } = createNamespacedHelpers('articles')

export default {
  name: 'RecentlyPublished',
  // -------------
  // Components ==
  // -------------
  components: { 
    ArticleTable
  },
  // -----------
  // Computed ==
  // -----------
  computed: {
    ...mapState([
      'recent'
    ])
  }
}
</script>
